import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=c8504974&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=c8504974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8504974",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8504974')) {
      api.createRecord('c8504974', component.options)
    } else {
      api.reload('c8504974', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=c8504974&scoped=true&", function () {
      api.rerender('c8504974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ra4qKPI393ug/JS/comp/SearchFilterTokens.vue"
export default component.exports